var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{staticClass:"bg-lateral",attrs:{"visible":_vm.drawer,"title":_vm.titulo,"size":_vm.porcentaje,"wrapper-closable":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.drawer=$event}}},[_c('template',{slot:"title"},[_vm._t("title-edit")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }